export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    const stuckElements = document.querySelectorAll('.js-stuck')

    stuckElements.forEach((el) => {
      let class_name = el.dataset.className || 'stuck'
      let scrollOffset = parseInt(el.dataset.scrollOffset || '0')
      window.addEventListener('scroll', () => {
        if (window.scrollY > el.offsetTop - scrollOffset - el.clientHeight) {
          el.classList.add(class_name)
        } else {
          el.classList.remove(class_name)
        }
      })
    })
  })
})()
